import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { ProductCreateWfoodcostAllergensPage } from "../product-create-wfoodcost-allergens/product-create-wfoodcost-allergens";
import { Globals } from "../../../../../globals";
import { ProductsServices } from "../../../services";
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProvidersServices } from "../../../../providers/services";
import { StaticsServices } from "../../../../services/statics";
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../../stock/stock-list/stock-list';
import { AnalyticsServices } from '../../../../services/analyticsServices';

/**
 * Generated class for the ProductCreateWfoodcostStockPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-create-wfoodcost-stock',
  templateUrl: 'product-create-wfoodcost-stock.html',
})
export class ProductCreateWfoodcostStockPage {

  public form: FormGroup;
  product_name: any;
  product_uid: string;
  update_state: boolean = false;
  product_measurement: String;
  product: any;
  show_alert: boolean = true;
  old_stock: number = 0;
  deduct_stock: boolean;
  deduct_foodcost: boolean;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public productsServices: ProductsServices,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public providersServices: ProvidersServices,
    public staticsServices: StaticsServices,
    public translate: TranslateService,
    private alertCtrl: AlertController,
    private analyticsService: AnalyticsServices) {
    //Params
    this.update_state = this.navParams.get('update_state');
    this.product_name = this.navParams.get('product_name');
    this.product_uid = this.navParams.get('product_uid');
    this.product_measurement = this.navParams.get('product_measurement');
    this.product = this.navParams.get('product');

    if (this.product.deduct_stock) {
      this.deduct_stock = true;
    } else {
      this.deduct_foodcost = true;
    }
    //Si hacemos update adamptamos la informacion
    if (this.update_state) {
      this.old_stock = this.navParams.get('stock');
      this.productsServices.product_tags = this.navParams.get('tags');

      var stock_max = 0;
      if (this.navParams.get('stock_max')) {
        stock_max = this.navParams.get('stock_max')
      }

      this.form = fb.group({
        stock: [this.navParams.get('stock')],
        stock_alert: [this.navParams.get('stock_alert')],
        stock_max: [stock_max],
        reference : [this.navParams.get('reference')] || "" ,
        //sub_recipe: [false],
        reason: '',
        reason_desc: '',
      });

    } else {
      this.productsServices.product_tags = Array();

      this.form = fb.group({
        stock: [0],
        stock_alert: [0],
        stock_max: [0],
        reference : [""] ,
        //sub_recipe: [false],
        reason: 'new_product',
        reason_desc: '',
      });
    }
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.show_alert && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.productsServices.afs.collection('products').doc(this.product_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  submit() {
    if (this.form.valid) {
      this.show_alert = false;
      this.update();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-motivo-modificacion'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  update() {
    this.productsServices.afs.collection('products').doc(this.product_uid).update({
      'stock': this.form.value.stock,
      'stock_alert': this.form.value.stock_alert,
      'stock_max': this.form.value.stock_max,
      'reference' : this.form.value.reference ,
      'updated_at': new Date(),
      'updated_user': this.globals.user_name
    }).then(() => {
      //dataset
      //Enviamos la informacion a collection _data
      this.sendStockAnalytics();
      this.analyticsService.trackingExpStock('modify_stock', this.globals.tracking_exp['modify_stock'], this.product_uid);
      if (this.update_state) {
        this.globals.GAtrackView('Products', 'Products - Stock - Update', this.globals.restaurant.email, 'Create/Update', 'Update stock', 'Products', this.product_name);
        //DataSet Update
        this.sendData();
        this.sendDataChangeStock();
        this.navCtrl.pop();
      } else {
        this.globals.GAtrackView('Products', 'Products - Stock - Create', this.globals.restaurant.email, 'Create/Update', 'Create stock', 'Products', this.product_name);
        //DataSet Create
        this.navCtrl.push(ProductCreateWfoodcostAllergensPage, {
          update_state: false,
          product_uid: this.product_uid,
          product_name: this.product_name,
          product_measurement: this.product_measurement,
        });
      }

    });
  }

  sendData() {
    var extra = {
      "min_stock": this.form.value.stock_alert,
      "max_stock": this.form.value.stock_max,
    };
    this.globals.dataSet('product_name', this.product_name, '', JSON.stringify(extra));
    //this.globals.dataSet('product_price', this.form.value.pvp, '', this.product_name);
  }

  sendDataChangeStock() {
    var extra = {
      "stock": this.form.value.stock,
      "min_stock": this.form.value.stock_alert,
      "max_stock": this.form.value.stock_max,
      'reference' : this.form.value.reference ,
      "reason": this.form.value.reason,
      "reason_desc": this.form.value.reason_desc,
    };
    this.globals.dataSet('product_stock', this.product_name, '', JSON.stringify(extra));
  }

  async sendStockAnalytics() {
    let product = await this.productsServices.getProduct(this.product_uid);
    var stock = {
      "elements": [{
        "uid_element": this.product_uid,
        "name": this.product_name,
        "price": Math.abs(product.price_static * (this.form.value.stock - this.old_stock)), //Siempre numero positivo
        "quantity": (this.form.value.stock - this.old_stock),
        "measurement": product.measurement,
        "modifier": "",
      }],
      "uid": this.globals.restaurant_uid,
      "date": new Date(),
      "type": "stock",
      "comment": this.form.value.reason + "-" + this.globals.user_name + "-" + this.form.value.reason_desc,
      "type_type": "MANUAL",
      "delivery_uid": null
    };
    this.analyticsService.sendStock(stock);
  }

  updateIonToggleStock(value, type) {
    if (type == 'deduct_foodcost' && value) {
      this.deduct_stock = false;
      this.deduct_foodcost = true;
    } else if (type == 'deduct_stock' && value) {
      this.deduct_stock = true;
      this.deduct_foodcost = false;
    }

    this.productsServices.afs.collection('products').doc(this.product_uid).update({
      'deduct_stock': this.deduct_stock,
      'updated_at': new Date(),
      'updated_user': this.globals.user_name
    });
    this.product.deduct_stock = this.deduct_stock;
  }

}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-stock/product-create-wfoodcost-stock.ts